import { Button, Col, Divider, Form, Image, Input, Row, Select } from "antd";
import { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { dispatchtoast } from "../../../Utils";
import dropDownImage from "../../../Assets/ChevronDown.png";
import { addSubscribers } from "./SubscriberApi";
function AddSubscriber() {
  const location = useLocation();
  const fill = location.state?.fill;
  const from = location.state?.from;
  const [form] = Form.useForm();
  const formRef = useRef(form);
  const [isLoading, setIsLoading] = useState(false);
  console.log(from, fill);

  const navigate = useNavigate();
  const AddCasino = (values) => {
    console.log(values);
    const payload = {
      isActive: values.isActive,
      email: values.email,
    };

    setIsLoading(true);
    addSubscribers(payload)
      .then((response) => {
        if (response.status) {
          navigate("/get/subscriber_details");
          form.resetFields();
          setIsLoading(false);
        } else {
          dispatchtoast("Fields can not be empty", true);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  return (
    <div>
      <Divider
        orientation="left"
        style={{ border: "#cecece" }}
        className="text-base tracking-normal font-dmsans font-normal  text-gray-900"
      >
        Add Subscriber
      </Divider>
      <Form
        className="bg-white mt-6"
        layout="vertical"
        onFinishFailed={(err) => {
          err?.errorFields?.forEach((field) => {
            field.errors?.forEach((error) => {
              dispatchtoast(error, true);
            });
          });
        }}
        onFinish={(values) => AddCasino(values)}
        form={form}
        ref={formRef}
      >
        <Row className="grid grid-cols-1 sm:grid-cols-2  gap-4">
          <Col>
            <Form.Item
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  Email Address
                </p>
              }
              name="email"
            >
              <Input
                placeholder="e.g.,email should be greater then 0"
                type="email"
              />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  Active Status
                </p>
              }
              name="isActive"
              rules={[{ required: true, message: "Please select an option" }]}
            >
              <Select
                placeholder="True"
                suffixIcon={<Image src={`${dropDownImage}`} preview={false} />}
              >
                {[
                  { label: "True", value: true },
                  { label: "False", value: false },
                ].map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row className="flex justify-between">
          <Form.Item>
            <Button
              onClick={() => {
                from === "edit"
                  ? navigate("/get/subscriber_details")
                  : form.resetFields();
              }}
              className="RemoveButtonHover cancel-button"
              size="small"
              htmlType="onSubmit"
            >
              Cancel
            </Button>
          </Form.Item>

          <Form.Item>
            <Button
              className="NoButtonHover create-button"
              size="small"
              htmlType="submit"
              loading={isLoading}
            >
              Create Subscriber
            </Button>
          </Form.Item>
        </Row>
      </Form>
    </div>
  );
}

export default AddSubscriber;
